import { render, staticRenderFns } from "./report-instagram.vue?vue&type=template&id=19a5b5c5&scoped=true&"
import script from "./report-instagram.vue?vue&type=script&lang=js&"
export * from "./report-instagram.vue?vue&type=script&lang=js&"
import style0 from "./report-instagram.vue?vue&type=style&index=0&id=19a5b5c5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a5b5c5",
  null
  
)

export default component.exports